module.exports = __webpack_public_path__ + "assets/img/KS8123Plus-M.1d894814.png";